module.exports = __webpack_public_path__ + "static/media/instagram.2b0f5cbf.svg";